import { appConfig } from 'config/customization';
import { topbarSize } from 'constants/sizes';
import { small } from 'constants/fonts';
import Device from 'constants/deviceSizes';

export default {
  container: {
    position: 'fixed',
    display: 'flex',
    height: topbarSize,
    width: '100%',
    boxShadow: `0 0 15px 5px ${appConfig.colors.translucentGray}`,
    backgroundColor: appConfig.colors.topbarColor,
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 6,
    [Device.tablet_mobile]: {
      zIndex: 3,
      justifyContent: !appConfig.mobileTopbarLogo && 'flex-end'
    }
  },

  title: {
    fontSize: 21,
    fontWeight: 600,
    margin: '0px 22px',
    [Device.tablet_mobile]: {
      fontSize: 0
    }
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [Device.tablet_mobile]: {
      justifyContent: 'flex-end',
      paddingLeft: 15,
      textAlign: 'left'
    }
  },
  userInfo: {
    [Device.tablet_mobile]: {
      fontSize: small
    }
  },
  utilityLogo: {
    alignSelf: 'center',
    height: appConfig.publicHomeWithLogo ? '60%' : '90%',
    paddingLeft: 10,
    width: 'auto',
    cursor: 'pointer',
    [Device.tablet_mobile]: {
      paddingLeft: 70,
      display: appConfig.mobileTopbarLogo ? 'flex' : 'none'
    }
  }
};
